import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminBackgroundTaskType } from '../../enums/admin-background-task-type';
import { BackgroundTaskTypePipe } from '../../pipes';

@Component({
  selector: 'app-admin-background-task-type',
  imports: [CommonModule, BackgroundTaskTypePipe],
  templateUrl: './admin-background-task-type.component.html',
  styleUrl: './admin-background-task-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBackgroundTaskTypeComponent {
  public readonly type = input.required<AdminBackgroundTaskType>();

  protected readonly cssClass = computed(() => {
    switch (this.type()) {
      case AdminBackgroundTaskType.OrderComplete:
        return 'text-lime-600';

      case AdminBackgroundTaskType.SimulateOrderComplete:
        return 'text-orange-600';

      case AdminBackgroundTaskType.OrderLabelsPackageGenerate:
        return 'text-sky-700';

      case AdminBackgroundTaskType.SubscriptionProcess:
        return 'text-violet-600';

      case AdminBackgroundTaskType.SubscriptionPriceChanging:
        return 'text-amber-600';

      default:
        return '';
    }
  });
}
